import store from '@/store'
import { isOidcEnabled } from '@/common/helpers'

export const hasAccess = () => {
  if (!isOidcEnabled()) {
    return true
  }
  return store.getters['oidcStore/oidcIsAuthenticated'] || false
}
